export default {
    list: [],
    exclusiveSystem: [],
    exclusiveBill: '',
    exclusiveDiscount: '',
    soldoutList:[],
    clusterlist:[],
    OverViewList:[],
    TotalExclusivenum: 0,
    Activenum: 0,
    Toexpirenum: 0,
    Expirednum: 0,
    Othernum: 0,
    dr1num: 0,
    dc1num: 0,
    dc2num: 0,
    ds2num: 0,
    dn2num: 0,
    ag1num: 0,
    dr3num: 0,
    ds3num: 0,
    ds6num: 0,
    tagKeySetV2: {},
    tagValueSetV2: {},
};
